import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppHeader from '../layout/AppHeader';

function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <>
            <AppHeader />
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '70vh',
                textAlign: 'center',
                padding: '2rem'
            }}>
                <h1 style={{ fontSize: '6rem', fontWeight: '800', opacity: 0.15, marginBottom: '0' }}>404</h1>
                <h2 style={{ marginBottom: '0.75rem' }}>Page Not Found</h2>
                <p style={{ color: '#666', marginBottom: '1.5rem', maxWidth: '400px' }}>
                    The page you're looking for doesn't exist or has been moved.
                </p>
                <div style={{ display: 'flex', gap: '12px' }}>
                    <button
                        className="btn-custom btn-custom-primary"
                        onClick={() => navigate('/')}
                    >
                        Go Home
                    </button>
                    <button
                        className="btn-custom btn-custom-secondary"
                        onClick={() => navigate(-1)}
                    >
                        Go Back
                    </button>
                </div>
            </div>
        </>
    );
}

export default NotFoundPage;
